import React from 'react';

interface ExportHealthDataProps {
  childId: string;
}

export const ExportHealthData: React.FC<ExportHealthDataProps> = ({ childId }) => {
  return (
    <div className="bg-white rounded-xl border p-6">
      <h2 className="text-lg font-display font-semibold mb-4">Export Health Data</h2>
      <p className="text-warm-gray">Export functionality coming soon.</p>
    </div>
  );
};

export default ExportHealthData;
